import PropTypes from 'prop-types';
import styles from './cardList.module.scss';
import Card from '../card/card';

export default function CardList({ title = '', headline = '', cards = [] }) {
  return (
    <div className={styles.cardList}>
      {(title || headline) && (
        <div className={styles.header}>
          {title && <h1 className={styles.title}>{title}</h1>}
          {headline && <h2 className={styles.headline}>{headline}</h2>}
        </div>
      )}
      {cards.length > 0 && (
        <div className={styles.grid}>
          {cards.map((card, index) => {
            const key = `card-${index}`;
            return (
              <div
                key={key}
                className={
                  card.width === '50%' ? styles.gridItem50 : styles.gridItem100
                }
              >
                <Card {...card} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

CardList.propTypes = {
  title: PropTypes.string,
  headline: PropTypes.string,
  cards: PropTypes.array,
};
